<fhm-search-page [gridData]="gridData" [showLink]="true" [showAdd]="false" [type]="'user-search'" [columns]="['email', 'role']"
                 (selectRecord)="recordSelected($event)" [showDelete]="false"></fhm-search-page>
